import BaseListPage from "../../../../base/BaseListPage";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import Search from "../../../../components/Search";
import Table from "../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../utils/withRouter";
import ManageClientListPresenter from "./MangeClientListPresenter";

class ManageClientListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ManageClientListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      upsertUseCase(),
      deleteObjectUseCase(),
    );

    this.fieldsToDisplay = ["code", "name", "group"];
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "affiliates";
  }

  onClickDeleteItem(index) {
    this.presenter.onClickDeleteItem(index);
  }

  getActions() {
    return [
      {
        label: "Delete",
        onClick: this.onClickDeleteItem.bind(this),
        icon: "bi bi-trash",
        classes: "btn-light",
      },
      {
        label: "Edit",
        onClick: this.onClickItem.bind(this),
        icon: "bi bi-pencil-square",
      },
    ];
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count } = this.state;

    return (
      <PageContainer
        title="Manage Client"
        buttonHandler={this.onClickAdd.bind(this)}
        infiniteScroll={{
          loadMore: this.loadMore.bind(this),
          hasMore: !loading && count > objects.length,
        }}
      >
        <Search
          schemas={this.getSchemas()}
          className="w-50"
          onSubmit={this.searchSubmit.bind(this)}
          fields={schema.fields}
        />
        <Table
          fields={schema.fields}
          objects={objects}
          collapsable
          progress={loading}
          actions={this.getActions.bind(this)}
          excludeFields={Object.keys(schema.fields).filter(
            (key) => !this.fieldsToDisplay.includes(key),
          )}
        />
      </PageContainer>
    );
  }
}

export default withRouter(ManageClientListPage);
